module.exports = __webpack_public_path__ + "img/mini-home-image.166613ba.png";